import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import 'core-js/features/string/includes';
import 'core-js/features/object/entries';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { BrandProvider } from '@hcsc-fiber/react';
import { ThemeProvider } from 'styled-components';
import { getThemeForBrand } from './styles/theme';
import { WithAppContext } from './store';
import { WithAEMContext } from './store/aemStore';
import { BrowserRouter as Router } from 'react-router-dom';
import { getStateCodeSpecificUrlUsingProcessEnv } from './helpers/navigationHelper';
import { BRAND_CODES, getBrandContext } from './brand';
import FiberBrandSync from './brand/FiberBrandSync';
import LoaderSpinner from './components/common/LoadingSpinner';

const App = lazy(() => import('./App'));

const basePathName = process.env.PUBLIC_URL;
const { brandCode } = getBrandContext();
const initialBrand = brandCode === BRAND_CODES.HEALTHSPRING
    ? BRAND_CODES.HEALTHSPRING
    : BRAND_CODES.BCBS;
const theme = getThemeForBrand(initialBrand);
// Inject Adobe Analytics using runtime config (config already loaded synchronously)
const { adobeAnalyticsURL } = getStateCodeSpecificUrlUsingProcessEnv();
if (adobeAnalyticsURL) {
    const script = document.createElement('script');
    script.src = adobeAnalyticsURL;
    script.async = true;
    document.head.appendChild(script);
}


ReactDOM.render(
    <React.StrictMode>
        <BrandProvider initialBrand={initialBrand}>
            <FiberBrandSync>
                <ThemeProvider theme={theme}>
                    <WithAEMContext>
                        <WithAppContext>
                            <Router basename={basePathName}>
                                <Suspense fallback={<LoaderSpinner />}>
                                    <App />
                                </Suspense>
                            </Router>
                        </WithAppContext>
                    </WithAEMContext>
                </ThemeProvider>
            </FiberBrandSync>
        </BrandProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);
